import { render, staticRenderFns } from "./admZ010.vue?vue&type=template&id=4c2a03c4&scoped=true"
import script from "./admZ010.vue?vue&type=script&lang=js"
export * from "./admZ010.vue?vue&type=script&lang=js"
import style0 from "./admZ010.vue?vue&type=style&index=0&id=4c2a03c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2a03c4",
  null
  
)

export default component.exports